import { ROUTES } from "./routes";

export const CONTENT_PATHS = {
    NOTICE_BANNER: `/${ROUTES.NOTICE_BANNER}?lang=en`,
    HOME_ENABLING_BUSINESS_CAROUSEL: `/${ROUTES.HOME_ENABLING_BUSINESS_CAROUSEL}`,
    HOME_INFO_GUIDES_CAROUSEL: `/${ROUTES.HOME_INFO_GUIDES_CAROUSEL}`,
    REGISTRY_INSTRUCTION_INTRO: `/${ROUTES.REGISTRY_INSTRUCTION_INTRO}`,
    INFORMATION_PRODUCTS: `/${ROUTES.INFORMATION_PRODUCTS}`,
    BUY_INFO: `/${ROUTES.BUY_INFO}`
}

export const SKIP_SEO = [
    '/crm/' 
]